import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-721b4400"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "options-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "note" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"12px"} }, "単品購入（7,700円）よりも2,200円お得に本体同系色のベルトがセット"),
  /*#__PURE__*/_createTextVNode("になります。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" ※マジかるベルトはシミュレータ上に反映されません。予めご了承ください。 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormOption = _resolveComponent("FormOption")!
  const _component_RandselDialog = _resolveComponent("RandselDialog")!

  return (_openBlock(), _createBlock(_component_RandselDialog, {
    ref: "root",
    title: "タイプを選んでね",
    showEventName: "openBagtypeDialog",
    class: "bagtype-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
          return (_openBlock(), _createBlock(_component_FormOption, {
            class: "type-option",
            optionType: 'bagsize',
            key: item.id,
            option: item,
            onClick: ($event: any) => (_ctx.onClick(item)),
            isSelected: _ctx.currentSelection == item.id
          }, null, 8, ["option", "onClick", "isSelected"]))
        }), 128)),
        _hoisted_2
      ])
    ]),
    _: 1
  }, 512))
}